import Vue from "vue";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import router from "@/router/index";

Sentry.init({
  Vue,
  dsn: "https://612fee9a1ae24d69a7c918e8cf8131f8@logs.corp.jetstyle.in/31",
  release: `kk-landing@${process.env.VUE_APP_VERSION}`,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [
        "localhost",
        "talent.test.kruzhok.org",
        "talent.kruzhok.org",
        /^\//,
      ],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.5,
  // Пока оставляю так, потому что трек сессий вызывает корс ошибку на старой сентри
  // Пока мы не обновили ее до новой версии на желтом сервере
  // @see https://github.com/getsentry/sentry-javascript/issues/2859
  // autoSessionTracking: false,
  beforeBreadcrumb(crumb) {
    // удаляю крошки про вебвизор, их много
    if (
      crumb?.category === "xhr" &&
      crumb?.data?.url?.startWith("https://mc.yandex.ru/")
    ) {
      return null;
    }
    return crumb;
  },
});
